import { extractDate } from '../../public/utils/common';
import { RestBuilder } from '../../public/utils/rest';
import schema from '../schema';

import {
    urlForTickersDetail,
    paramsForGET,
} from '../../common/rest';

import {
    saveTickersDetailAction,
    setCurrentDateAction,
    setCurrentTimeAction,
} from '../../common/action-creators/domainData';

import {
    currentDateSelector,
} from '../../common/selectors/domainData';

export const START_SESSION = 'session/START';
export const STOP_SESSION = 'session/STOP';

export const startSessionAction = loadCallback => ({
    type: START_SESSION,
    loadCallback,
});

export const stopSessionAction = () => ({
    type: STOP_SESSION,
});


class SessionManager {
    constructor(store) {
        this.store = store;
    }

    // TODO: run for eternity
    createRequestForTickersDetail = (store) => {
        const requestForTickersDetail = new RestBuilder()
            .url(urlForTickersDetail)
            .retryTime(1000)
            .maxRetryTime(10)
            .params(paramsForGET())
            .success((response) => {
                try {
                    schema.validate(response, 'tickerDetailResponse');
                    store.dispatch(saveTickersDetailAction({
                        tickersDetail: response.data,
                    }));

                    if (this.loadCallback) {
                        this.loadCallback();
                    }
                } catch (er) {
                    console.error(er);
                }
            })
            // TODO: handle failure
            .build();
        return requestForTickersDetail;
    }

    loadCurrentDateTime = (store) => {
        const currentDate = currentDateSelector(store.getState());

        const unixDateTimeNow = Date.now();
        const unixDateNow = extractDate(unixDateTimeNow);

        if (unixDateNow !== currentDate) {
            store.dispatch(setCurrentDateAction({
                timeStamp: unixDateNow,
            }));
        }
        store.dispatch(setCurrentTimeAction({
            timeStamp: unixDateNow,
        }));
    }


    start = (loadCallback) => {
        this.stop();
        this.loadCallback = loadCallback;

        this.requestForTickerDetail = this.createRequestForTickersDetail(this.store);
        this.requestForTickerDetail.start();

        this.loadCurrentDateTimeInterval = setInterval(
            () => this.loadCurrentDateTime(this.store),
            1000,
        );
    }

    stop = () => {
        if (this.requestForTickerDetail) {
            this.requestForTickerDetail.stop();
        }
        if (this.loadCurrentDateTimeInterval) {
            clearInterval(this.loadCurrentDateTimeInterval);
        }
    }
}

const sessionMiddleware = (store) => {
    const manager = new SessionManager(store);
    return next => (action) => {
        // store, next, action
        switch (action.type) {
            case START_SESSION:
                manager.start(action.loadCallback);
                break;
            case STOP_SESSION:
                manager.stop();
                break;
            default:
        }
        return next(action);
    };
};

export default sessionMiddleware;



// WEBPACK FOOTER //
// ./src/common/middlewares/authManager.js